module.exports = __webpack_public_path__ + "img/45.531a3452.jpg";